export default __webpack_public_path__ + "static/media/favorite-on-white.8c49d397.svg";